export default () => [
  {
    field: "seq",
    minWidth: 50,
    align: "center",
    fixed: "left",
    type: "seq",
  },
  {
    field: "icechopsNo",
    align: "center",
    fixed: "left",
    minWidth: 200,
    title: "冰排编号",
    sortable: false,
    showHeaderOverflow: "title",
    showOverflow: "ellipsis",
  },
  {
    field: "oldLocationNo",
    align: "center",
    minWidth: 150,
    title: "原库位号",
    sortable: true,
    sortType: "float",
    showHeaderOverflow: "title",
    showOverflow: "ellipsis",
  },
  {
    field: "locationNo",
    align: "center",
    minWidth: 150,
    title: "目标库位号",
    sortable: true,
    sortType: "float",
    showHeaderOverflow: "title",
    showOverflow: "ellipsis",
  },

  {
    field: "optType",
    align: "center",
    minWidth: 100,
    title: "操作类型",
    slots: { default: "type" },
    showHeaderOverflow: "title",
    showOverflow: "ellipsis",
  },
  {
    field: "optByName",
    align: "center",
    minWidth: 150,
    title: "操作人",
    showHeaderOverflow: "title",
    showOverflow: "ellipsis",
  },
  {
    field: "optTime",
    align: "center",
    minWidth: 150,
    title: "操作时间",
    showHeaderOverflow: "title",
    showOverflow: "ellipsis",
  },
  {
    field: "optDesc",
    align: "center",
    minWidth: 150,
    title: "操作描述",
    showHeaderOverflow: "title",
    showOverflow: "ellipsis",
  },
]
